export * from "-!../../../node_modules/vue-loader/lib/loaders/templateLoader.js??ref--1!../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./kexie.vue?vue&type=template&id=08d3020a&"


//////////////////
// WEBPACK FOOTER
// ./src/views/kexie/kexie.vue?vue&type=template&id=08d3020a&
// module id = null
// module chunks = 